import { jsx as n, Fragment as c, jsxs as S } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { S as z } from "./index-DoOsnuB6.js";
import { c as y } from "./index-BNmRGtA6.js";
import { c as u } from "./clsx-OuTLNxxd.js";
import { S as x } from "./Spinner-LiIAKUHF.js";
import './Button.css';const h = "_buttonBase_1rsdf_75", B = "_button_1rsdf_75", b = "_xxSmallSize_1rsdf_119", g = "_xSmallSize_1rsdf_127", p = "_smallSize_1rsdf_135", v = "_defaultSize_1rsdf_143", F = "_largeSize_1rsdf_149", N = "_iconSize_1rsdf_157", W = "_primary_1rsdf_166", j = "_secondary_1rsdf_175", V = "_tertiary_1rsdf_188", k = "_ghost_1rsdf_210", w = "_ghostBrand_1rsdf_211", C = "_outline_1rsdf_251", R = "_surface_1rsdf_264", q = "_isFullWidth_1rsdf_270", A = "_rounded_1rsdf_274", t = {
  buttonBase: h,
  button: B,
  xxSmallSize: b,
  xSmallSize: g,
  smallSize: p,
  defaultSize: v,
  largeSize: F,
  iconSize: N,
  primary: W,
  secondary: j,
  tertiary: V,
  ghost: k,
  ghostBrand: w,
  outline: C,
  surface: R,
  isFullWidth: q,
  rounded: A
}, D = y(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      outline: t.outline,
      surface: t.surface
    },
    size: {
      "xx-small": t.xxSmallSize,
      "x-small": t.xSmallSize,
      small: t.smallSize,
      default: t.defaultSize,
      large: t.largeSize,
      icon: t.iconSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), f = d(
  ({ asChild: i = !1, className: a, disabled: e, pressed: s, ...o }, r) => {
    const l = i ? z : "button", m = s === void 0 ? void 0 : { "aria-pressed": s, "data-state": s ? "on" : "off" };
    return /* @__PURE__ */ n(
      l,
      {
        className: u(t.buttonBase, a),
        "data-cxy-name": "button-base",
        disabled: e,
        ref: r,
        ...o,
        ...m
      }
    );
  }
), E = d(
  ({ asChild: i, isLoading: a, loadingText: e, variant: s, ...o }, r) => /* @__PURE__ */ n(c, { children: a ? /* @__PURE__ */ n(_, { ...o, "aria-busy": a, disabled: a, ref: r, variant: s, children: /* @__PURE__ */ S(c, { children: [
    e || "Loading",
    /* @__PURE__ */ n(x, { size: "s", variant: s === "secondary" ? "dark" : "light" })
  ] }) }) : /* @__PURE__ */ n(_, { ...o, asChild: i, ref: r, variant: s }) })
), _ = d(
  ({ className: i, isFullWidth: a, rounded: e, size: s, variant: o, ...r }, l) => /* @__PURE__ */ n(
    f,
    {
      className: u(
        D({ variant: o, size: s }),
        { [t.isFullWidth]: a, [t.rounded]: e },
        i
      ),
      "data-cxy-name": "button",
      "data-testid": "button-component",
      ref: l,
      ...r
    }
  )
);
E.displayName = "Button";
f.displayName = "ButtonBase";
export {
  E as B,
  f as a,
  D as b
};
